const ITEMS_PER_PAGE = 6;
let allVendors = [];
let filteredVendors = [];
let currentPage = 1;

// API URLs
const API_URLS = {
    dev: 'https://dev.eplan-inc.com/DEV/partner-gateway/public/plan/integration/vendors/active',
    prod: 'https://secure.eplanservices401k.com/PROD/partner-gateway/public/plan/integration/vendors/active'
};

// Determine which URL to use based on current environment
const getVendorsUrl = () => {
    const isDev = window.location.hostname.includes('dev');
    return isDev ? API_URLS.dev : API_URLS.prod;
};

// Debounce utility function to delay expensive operations
function debounce(func, delay = 300) {
    let timeoutId;
    return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
}

// Helper function to set up modal focus restoration
function setupModalFocusHandler(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    
    modal.addEventListener('hide.bs.modal', function() {
        if (typeof queueMicrotask !== 'undefined') {
            queueMicrotask(() => {
                const focused = document.activeElement;
                if (focused && modal.contains(focused)) {
                    const search = document.getElementById('vendor-search');
                    if (search) {
                        search.focus();
                    }
                }
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    fetchAndDisplayVendors();
    
    // Add search listener with debouncing to reduce filtering on every keystroke
    const searchInput = document.getElementById('vendor-search');
    if (searchInput) {
        const debouncedSearch = debounce(handleSearch, 300);
        searchInput.addEventListener('input', debouncedSearch);
    }

    // Set up focus restoration for both modals
    setupModalFocusHandler('vendorModal');
    setupModalFocusHandler('salesModal');
    
    // Handle sales modal open to populate vendor name and set select field
    const salesModal = document.getElementById('salesModal');
    if (salesModal) {
        salesModal.addEventListener('show.bs.modal', function() {
            const selectElement = document.querySelector('.select-discuss select');
            if (selectElement) {
                // Remove any previous change listeners to avoid duplicates
                const newSelectElement = selectElement.cloneNode(true);
                selectElement.parentNode.replaceChild(newSelectElement, selectElement);
                
                // Add fresh listener to show/hide textarea based on select value
                newSelectElement.addEventListener('change', function handleTextareaToggle() {
                    const textareadiv = document.querySelector('.textarea-more');
                    const textarea = document.querySelector('.textarea-more textarea');
                    if (textareadiv) {
                        if (this.value === 'Other') {
                            textareadiv.style.display = 'block';
                            // Enable textarea when showing
                            if (textarea) {
                                textarea.removeAttribute('disabled');
                            }
                        } else {
                            textareadiv.style.display = 'none';
                            // Disable textarea when hiding
                            if (textarea) {
                                textarea.setAttribute('disabled', 'disabled');
                            }
                        }
                    }
                });
            }

            const selectValue = sessionStorage.getItem('selectValue');
            const updatedSelectElement = document.querySelector('.select-discuss select');
            if (selectValue) {
                // Set select field to the specified value
                setSelectFieldOption(selectValue);
                // Clear the flag after use
                sessionStorage.removeItem('selectValue');
                } else {
                // Clear form fields if no selectValue is set (standalone "Contact sales" button)
                if (updatedSelectElement) {
                    updatedSelectElement.value = 'Select an option';
                }
                const textareadiv = document.querySelector('.textarea-more');
                if (textareadiv) {
                    textareadiv.style.display = 'none';
                }
                const textarea = document.querySelector('.textarea-more textarea');
                if (textarea) {
                    textarea.value = '';
                    textarea.setAttribute('disabled', 'disabled');
                }
            }
        });
    }

});

function handleSearch(e) {
    const searchTerm = e.target.value.toLowerCase().trim();
    
    if (searchTerm === '') {
        filteredVendors = [...allVendors];
    } else {
        filteredVendors = allVendors.filter(vendor => 
            vendor.vendorName.toLowerCase().includes(searchTerm)
        );
    }
    
    currentPage = 1;
    displayPageVendors();
    createPagination();
}

async function fetchAndDisplayVendors() {
    const vendorsGrid = document.getElementById('vendors-grid');
    const vendorsError = document.querySelector('.vendors-error');
    const vendorsLoading = document.querySelector('.vendors-loading');
    
    try {
        const response = await fetch(getVendorsUrl());
        const data = await response.json();

        if (data.responseStatus === 'Success') {
            let vendors = data.data.activePayrollVendors;
            
            if (vendors && vendors.length > 0) {

                // Filter out vendors where isHideFromSearch is true
                vendors = vendors.filter(vendor => !vendor.isHideFromSearch);

                // Sort vendors: featured marketing vendors first, then alphabetically by name
                vendors.sort((a, b) => {
                    // First, sort by featured status (featured first)
                    const aFeatured = a.featuredMarketingVendor === 'Y';
                    const bFeatured = b.featuredMarketingVendor === 'Y';
                    if (bFeatured !== aFeatured) {
                        return bFeatured ? 1 : -1;
                    }
                    // Then, sort alphabetically by vendor name
                    return a.vendorName.localeCompare(b.vendorName);
                });
                
                allVendors = vendors;
                filteredVendors = vendors;
                currentPage = 1;
                
                if (vendorsLoading) vendorsLoading.remove();
                vendorsError.innerHTML = '';
                displayPageVendors();
                createPagination();
            } else {
                if (vendorsLoading) vendorsLoading.remove();
                vendorsError.innerHTML = '<div class="vendors-error">No vendors found.</div>';
            }
        } else {
            if (vendorsLoading) vendorsLoading.remove();
            vendorsError.innerHTML = '<div class="vendors-error">Failed to load vendors: ' + esc_html(data.errorMessage) + '</div>';
        }
    } catch (error) {
        console.error('Error fetching vendors:', error);
        if (vendorsLoading) vendorsLoading.remove();
        vendorsError.innerHTML = '<div class="vendors-error">Error loading vendors.</div>';
    }
}

function displayPageVendors() {
    const vendorsGrid = document.getElementById('vendors-grid');
    const vendorsError = document.querySelector('.vendors-error');
    const vendorsLoading = document.querySelector('.vendors-loading');
    
    // Remove the loading skeleton cards from DOM
    if (vendorsLoading) {
        vendorsLoading.remove();
    }
    
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const pageVendors = filteredVendors.slice(startIndex, endIndex);
    
    if (pageVendors.length === 0 && filteredVendors.length === 0) {
        // Set no results content without clearing first to avoid flicker
        vendorsGrid.innerHTML = '';
        vendorsError.innerHTML = '<div class="text-center"><img src="/marketing/wp-content/themes/marketing2025/img/icon-no-results-dark.svg" alt=""><p class="pt-4"> Sorry, but nothing matched your search terms. <br/> <br/> Please try again with some different keywords. <br/> Or <a href="#" id="no-results">contact us</a> to request the addition of your payroll provider.  </p></div>';
        
        // Add click handler to No results button immediately (no setTimeout needed)
        const noResultsBtn = document.getElementById('no-results');
        if (noResultsBtn) {
            noResultsBtn.addEventListener('click', function(e) {
                e.preventDefault();
                // Set flag to indicate "No results" was clicked, set select to "Other"
                sessionStorage.setItem('selectValue', 'Other');
                sessionStorage.removeItem('vendorName');

                // Get the search input value
                const searchInput = document.getElementById('vendor-search');
                const searchValue = searchInput ? searchInput.value : '';

                // Add text to textarea with search value
                const textarea = document.querySelector('.textarea-more textarea');
                if (textarea) {
                    if (searchValue) {
                        textarea.value = `I don't see my payroll provider on this list. Can you please add ${searchValue}?`;
                    }
                }

                // Set vendor name in input_1_22
                const vendorInput = document.querySelector('.input-payroll-vendor input');

                if (vendorInput) {
                vendorInput.value = '';
                }
                
                // Open sales modal
                const salesModal = document.getElementById('salesModal');
                if (salesModal) {
                    new bootstrap.Modal(salesModal).show();
                }
            });
        }
        return;
    }
    
    // Clear both containers only when displaying results
    vendorsGrid.innerHTML = '';
    vendorsError.innerHTML = '';
    
    pageVendors.forEach(vendor => {
        const vendorCard = createVendorCard(vendor);
        vendorsGrid.appendChild(vendorCard);
    });
}


let pendingFocusButton = null;


function createPagination() {
    const paginationContainer = document.getElementById('vendors-pagination');
    paginationContainer.innerHTML = '';
    
    const totalPages = Math.ceil(filteredVendors.length / ITEMS_PER_PAGE);
    
    if (totalPages <= 1) return;
    
    // Previous button
    const prevBtn = document.createElement('button');
    prevBtn.id = 'pagination-prev';
    prevBtn.className = 'btn-pagination';
    prevBtn.setAttribute('aria-label', 'Previous page');
    prevBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22" fill="none"><path d="M13.585 19.415L5.18833 11L13.585 2.585L11 0L0 11L11 22L13.585 19.415Z" fill="white"/></svg>';
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener('click', handlePaginationClick);
    prevBtn.addEventListener('keypress', handlePaginationKeypress);
    paginationContainer.appendChild(prevBtn);
    
    // Next button
    const nextBtn = document.createElement('button');
    nextBtn.id = 'pagination-next';
    nextBtn.className = 'btn-pagination';
    nextBtn.setAttribute('aria-label', 'Next page');
    nextBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="22" viewBox="0 0 14 22" fill="none"><path d="M0 19.415L8.39667 11L0 2.585L2.585 0L13.585 11L2.585 22L0 19.415Z" fill="white"/></svg>';
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener('click', handlePaginationClick);
    nextBtn.addEventListener('keypress', handlePaginationKeypress);
    paginationContainer.appendChild(nextBtn);
    
    // Restore focus if a button was previously focused
    if (pendingFocusButton) {
        const btnToFocus = document.getElementById(pendingFocusButton);
        if (btnToFocus && !btnToFocus.disabled) {
            setTimeout(() => btnToFocus.focus(), 0);
        }
        pendingFocusButton = null;
    }
}


function handlePaginationClick(e) {
    const btn = e.currentTarget;
    if (btn.id === 'pagination-prev' && currentPage > 1) {
        pendingFocusButton = 'pagination-prev';
        currentPage--;
        displayPageVendors();
        createPagination();
    } else if (btn.id === 'pagination-next' && currentPage < Math.ceil(filteredVendors.length / ITEMS_PER_PAGE)) {
        pendingFocusButton = 'pagination-next';
        currentPage++;
        displayPageVendors();
        createPagination();
    }
}

function handlePaginationKeypress(e) {
    if (e.key === 'Enter' || e.code === 'Space') {
        handlePaginationClick(e);
    }
}

function createVendorCard(vendor) {
     const card = document.createElement('button');
    card.className = 'vendor-card';
    card.type = 'button';
    card.setAttribute('aria-label', `Open ${vendor.vendorName} details`);
    
    // Build pill HTML using array for better performance
    const pills = [];
    if (vendor.payroll360IntegratedYN === 'Y') {
        pills.push('<span class="vendor-pill vendor-pill__360">360°</span>');
    } else if (vendor.payroll360IntegratedYN === 'N') {
        pills.push('<span class="vendor-pill vendor-pill__180">180°</span>');
    }
    
    if (vendor.featuredMarketingVendor === 'Y') {
        pills.push('<span class="vendor-pill featured">Featured</span>');
    }
    
    const vendorPill = pills.join('');

    const defaultImagePath = '/marketing/wp-content/themes/marketing2025/img/vendor-default.svg';
    const vendorImagePath = `/marketing/wp-content/themes/marketing2025/img/payroll-vendors/${vendor.vendorId}.svg`;
    
    // Use vendor image with fallback to default
    const vendorImage = `<div class="vendor-card__image w-50 text-end"><img src="${vendorImagePath}" alt="${vendor.vendorName}" onerror="this.src='${defaultImagePath}'" style=" object-fit: contain; object-position: right;" /></div>`;
    const vendorImageModal = `<div class="text-center"><img src="${vendorImagePath}" alt="${vendor.vendorName}" onerror="this.src='${defaultImagePath}'" style=" object-fit: contain; object-position: right; height:150px;" /></div>`;
    
    card.innerHTML = `
        <div class="w-50 d-flex flex-column justify-content-between">
        <div class="vendor-name">${vendor.vendorName}</div>
        <div>${vendorPill}</div>
        </div>
        ${vendorImage}
    `;

    card.addEventListener("click", function () {
      document.getElementById("vendorModalBody").innerHTML = `
             <div class="text-center pb-4">
                 ${vendorImageModal}
            </div>
        <h2>Integrate with ${vendor.vendorName}</h2>
            <p>Great news! ePlan Services can sync data with ${vendor.vendorName}. 
             <br/><br/>If you’re an administrator of your plan, you can request integration setup in <strong>Payroll Settings</strong>.</p>
             <a href="https://secure.eplanservices401k.com/PROD/sign-in-ui/#/" class="btn btn-primary-d" target="_blank">Sign in and integrate <span class="visually-hidden">opens in new tab</span></a>
             <h2>I use ${vendor.vendorName}, but don’t have an ePlan Services 401(k)</h2>
             <p>Want a 401(k) for your business that syncs with ${vendor.vendorName}, provides a simple-to-use system that promotes employee autonomy, and gives you time back with blistering-fast 24-hour setup? You're in the right place. <strong>Reach out to your financial advisor</strong> and ask them to contact our sales team.
            <br/><br/>
            Don’t have a financial advisor? You can <strong>contact sales</strong> directly, right here.</strong></p>
            <button type="button" class="btn btn-primary-d" id="vendor-sales-btn-${vendor.vendorId}" data-vendor-name="${vendor.vendorName}">  Book a no-pressure chat with sales </button>
        `;
      new bootstrap.Modal(document.getElementById("vendorModal")).show();
      
      // Add click handler to sales button to pass vendor name to sales modal
      setTimeout(() => {
        const salesBtn = document.getElementById(`vendor-sales-btn-${vendor.vendorId}`);
        if (salesBtn) {
          salesBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // Set flag to indicate select should be reset to default
            sessionStorage.setItem('selectValue', 'Select an option');
            sessionStorage.removeItem('vendorName');

            // Clear textarea
            const textarea = document.querySelector('.textarea-more textarea');
            if (textarea) {
              textarea.value = '';
            }

            // Set vendor name in input_1_22
            const vendorInput = document.querySelector('.input-payroll-vendor input');

            if (vendorInput) {
              vendorInput.value = vendor.vendorName;
            }
            
            // Close the vendor modal
            const vendorModal = document.getElementById('vendorModal');
            if (vendorModal) {
              bootstrap.Modal.getInstance(vendorModal).hide();
            }
            
            // Now open the sales modal
            const salesModal = document.getElementById('salesModal');
            if (salesModal) {
                new bootstrap.Modal(salesModal).show();
            }
          });
        }
      }, 0);
    });
    
    return card;
}

// Global Gravity Forms field setter function
function setGravityFormFieldValue(value) {
    var inputElement = document.querySelector('.input-payroll-vendor input');

    if (inputElement) {
        inputElement.value = value;
        var event = new Event('change');
        inputElement.dispatchEvent(event);
    } 
}

// Set select field option
function setSelectFieldOption(optionValue) {
    // Try to find select by Gravity Forms field ID
    let selectElement = document.querySelector('.select-discuss select');
    
    if (selectElement) {
        selectElement.value = optionValue;
        console.log(`Set select field to ${optionValue}`);
        // Trigger change event to notify any listeners
        const event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
        return true;
    }
    
    console.warn(`Select field not found`);
    return false;
}

